/**
 * Firebase Configuration Validation
 * Checks if Firebase environment variables are properly set
 */

export function validateFirebaseConfig() {
  const requiredVars = [
    'REACT_APP_FIREBASE_API_KEY',
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'REACT_APP_FIREBASE_PROJECT_ID',
    'REACT_APP_FIREBASE_STORAGE_BUCKET',
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    'REACT_APP_FIREBASE_APP_ID'
  ];

  const missing = [];
  const invalid = [];

  requiredVars.forEach(varName => {
    const value = process.env[varName];
    if (!value || value.trim() === '' || value.includes('your_') || value.includes('demo-')) {
      if (!value || value.trim() === '') {
        missing.push(varName);
      } else {
        invalid.push(varName);
      }
    }
  });

  if (missing.length > 0 || invalid.length > 0) {
    console.warn('⚠️ Firebase Configuration Issues:');
    if (missing.length > 0) {
      console.warn('Missing variables:', missing.join(', '));
    }
    if (invalid.length > 0) {
      console.warn('Invalid/placeholder values:', invalid.join(', '));
    }
    console.warn('Please check your .env file and follow FIREBASE_API_KEYS_GUIDE.md');
    return false;
  }

  return true;
}

export function getFirebaseConfigStatus() {
  const envMap = {
    apiKey: 'REACT_APP_FIREBASE_API_KEY',
    authDomain: 'REACT_APP_FIREBASE_AUTH_DOMAIN',
    projectId: 'REACT_APP_FIREBASE_PROJECT_ID',
    storageBucket: 'REACT_APP_FIREBASE_STORAGE_BUCKET',
    messagingSenderId: 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    appId: 'REACT_APP_FIREBASE_APP_ID'
  };

  const status = {
    isValid: true,
    missing: [],
    configured: []
  };

  Object.entries(envMap).forEach(([key, envKey]) => {
    const value = process.env[envKey];
    
    if (!value || value.trim() === '' || value.includes('your_') || value.includes('demo-')) {
      status.isValid = false;
      status.missing.push(envKey);
    } else {
      status.configured.push(envKey);
    }
  });

  return status;
}

